import * as actions from './actions';
import {addInterceptor} from 'admin-ng/util/request-promise';

export default dispatch => {
  addInterceptor('before', () => dispatch(actions.start()));
  addInterceptor('success', () => dispatch(actions.success()));
  addInterceptor('fail', () => dispatch(actions.fail()));
};
